import { Dataset } from '@/api/types/dataset.type'
import { KnowledgeDocType, KnowledgeStatus } from '@/api/types/knowledge.types'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * 知识库数据接口
 */
export interface Knowledge {
  /** 知识库唯一标识 */
  id: string
  /** 知识库名称 */
  name: string
  /** 知识库类型 */
  docType: KnowledgeDocType
  /** 知识库状态 */
  status: KnowledgeStatus
  /** 知识库创建人 */
  creator: string
  /** 知识库文件数量 */
  filesNum: number
}

/**
 * 知识库状态管理接口
 */
interface KnowledgeStore {
  /** 当前选中的知识库 */
  currentKnowledge: Knowledge | null
  /** 当前选中的数据集 */
  currentDataset: Dataset | null
  
  /** 设置当前选中的知识库 */
  setCurrentKnowledge: (knowledge: Knowledge | null) => void

  /** 设置当前选中的数据集 */
  setCurrentDataset: (dataset: Dataset | null) => void
  
  /** 清空当前选中的知识库 */
  clearCurrentKnowledge: () => void
}

/**
 * 知识库状态管理 Store
 * 
 * 功能：
 * - 管理当前选中的知识库
 * - 支持持久化存储
 * - 提供知识库的选中和清空操作
 */
export const useKnowledgeStore = create<KnowledgeStore>()(
  persist(
    (set) => ({
      // 当前选中的知识库
      currentKnowledge: null,
      // 当前选中的数据集
      currentDataset: null,
      
      // 设置当前选中的知识库
      setCurrentKnowledge: (knowledge) => {
        set({ currentKnowledge: knowledge })
      },
      // 设置当前选中的数据集
      setCurrentDataset: (dataset) => {
        set({ currentDataset: dataset })
      },
      
      // 清空当前选中的知识库
      clearCurrentKnowledge: () => {
        set({ currentKnowledge: null })
      },
    }),
    {
      // 持久化配置
      name: 'knowledge-store',
      // 持久化currentKnowledge和currentDataset
      partialize: (state) => ({
        currentKnowledge: state.currentKnowledge,
        currentDataset: state.currentDataset,
      }),
    }
  )
)
